import { Typography } from 'components/Contentful'
import { Slider } from '@achieve/ascend'
import { validateApr } from './utils'

function EstimatedApr({
  jsonConfig,
  licensedFlag,
  loanPayments,
  term,
  customAPR,
  helocUpdated,
  handleChangeCustomAPR,
  handleReleaseAmount,
  variant,
}) {
  return (
    <>
      <Typography
        content={jsonConfig?.estimateTitle || 'Estimated APR'}
        variant={variant || 'bodyLg'}
        mobileVariant="bodySm"
        responsive={true}
        data-testid="heloc-estimate"
        className="text-[#42546B]"
      />
      {licensedFlag ? (
        <Typography
          content={`${validateApr(loanPayments, term)}%`}
          variant="headingMd"
          fontWeight="bold"
          className="py-2"
        />
      ) : (
        <>
          <Typography
            content={`${customAPR.toFixed(3)}%`}
            variant="headingMd"
            fontWeight="bold"
            className="py-2"
          />
          {helocUpdated ? null : (
            <Slider
              aria-label="term-estimate-apr-slider"
              classes={{
                mark: 'hidden',
              }}
              data-testid="heloc-estimate-apr-form"
              value={customAPR}
              min={1}
              max={jsonConfig?.maxCustomAPR || 35}
              step={1}
              marks={[
                {
                  value: 1,
                  label: (
                    <Typography
                      content="0%"
                      variant="bodySm"
                      fontWeight="regular"
                      className={'text-[#5C708A] ml-8'}
                    />
                  ),
                },
                {
                  value: 35,
                  label: (
                    <Typography
                      content="35%"
                      variant="bodySm"
                      fontWeight="regular"
                      className={'text-[#5C708A] mr-10'}
                    />
                  ),
                },
              ]}
              onChange={handleChangeCustomAPR}
              onMouseUp={handleReleaseAmount}
              onTouchEnd={handleReleaseAmount}
            />
          )}
        </>
      )}
    </>
  )
}

export { EstimatedApr }
